import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import '../css/auth.css'
import '../css/deleteAccount.css'

function DeleteAccount() {
    const [lang, setLang] = useState('EN')

    useEffect(() => {
        document.title = "Account Deletion | Klerk"
    }, [])

    return (
        <div className="custom-container" style={{ position: 'absolute', width: '100%', left: '0px' }}>
            <div className="left delete-page">
                <div className="glass-card">
                    <div className="lang-toggle">
                        <button onClick={() => setLang('EN')} className={lang === 'EN' ? 'active' : ''}>EN</button>
                        <span>|</span>
                        <button onClick={() => setLang('FR')} className={lang === 'FR' ? 'active' : ''}>FR</button>
                    </div>

                    {lang === 'EN' ? (
                        <>
                            <h1>Account Deletion</h1>
                            <p className="subtitle">Learn how to delete your Klerk account and associated data.</p>
                            
                            <div className="instruction-grid">
                                <section className="glass-sub-card">
                                    <h2>Option 1: In the App</h2>
                                    <div className="step-list">
                                        <div className="step"><span>1</span> Open the Klerk app</div>
                                        <div className="step"><span>2</span> Go to Profile / Settings</div>
                                        <div className="step"><span>3</span> Tap Delete Account</div>
                                        <div className="step"><span>4</span> Confirm the request</div>
                                    </div>
                                    <p className="red-alert">This action is permanent and cannot be undone.</p>
                                </section>

                                <section className="glass-sub-card">
                                    <h2>Option 2: By Email</h2>
                                    <p>If you cannot access the app, you can request deletion by contacting:</p>
                                    <div className="email-box">
                                        <a href="mailto:info@klerk.com">info@klerk.com</a>
                                    </div>
                                    <p className="small-note">Please include the phone number associated with your Klerk account.</p>
                                </section>
                            </div>

                            <div className="data-policy-card">
                                <h3>Data Handling Policy</h3>
                                <div className="policy-item">
                                    <strong>What will be deleted:</strong> Phone number, User profile information, Visit history, Reward activity.
                                </div>
                                <div className="policy-item">
                                    <strong>What may be retained:</strong> Certain anonymized transaction records may be retained for analytics, fraud prevention, and legal compliance.
                                </div>
                                <div className="policy-item">
                                    <strong>Processing time:</strong> Account deletion requests are processed within 7 days.
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <h1>Suppression de compte</h1>
                            <p className="subtitle">Comment supprimer votre compte et vos données personnelles Klerk.</p>
                            
                            <div className="instruction-grid">
                                <section className="glass-sub-card">
                                    <h2>Option 1: Dans l’application</h2>
                                    <div className="step-list">
                                        <div className="step"><span>1</span> Ouvrez l’application Klerk</div>
                                        <div className="step"><span>2</span> Accédez à Profil / Paramètres</div>
                                        <div className="step"><span>3</span> Appuyez sur Supprimer le compte</div>
                                        <div className="step"><span>4</span> Confirmez la demande</div>
                                    </div>
                                    <p className="red-alert">Cette action est définitive et irréversible.</p>
                                </section>

                                <section className="glass-sub-card">
                                    <h2>Option 2: Par courriel</h2>
                                    <p>Si vous ne pouvez pas accéder à l’application, contactez:</p>
                                    <div className="email-box">
                                        <a href="mailto:info@klerk.com">info@klerk.com</a>
                                    </div>
                                    <p className="small-note">Veuillez inclure le numéro de téléphone associé à votre compte Klerk.</p>
                                </section>
                            </div>

                            <div className="data-policy-card">
                                <h3>Politique de données</h3>
                                <div className="policy-item">
                                    <strong>Données supprimées:</strong> Numéro de téléphone, Informations du profil utilisateur, Historique des visites, Activité liée aux récompenses.
                                </div>
                                <div className="policy-item">
                                    <strong>Données conservées:</strong> Certaines données transactionnelles anonymisées peuvent être conservées.
                                </div>
                                <div className="policy-item">
                                    <strong>Délai:</strong> Les demandes sont traitées dans un délai maximal de 7 jours.
                                </div>
                            </div>
                        </>
                    )}

                    <div className="footer-links">
                        <Link to="/" className="btn-outline">Back to Login</Link>
                    </div>
                </div>
            </div>
            <button className="support-btn" onClick={() => window.location.href='mailto:info@klerk.com'}>
                Contact Support
            </button>
        </div>
    )
}

export default DeleteAccount
